
namespace TabAurous.SalesOrder{

    @Serenity.Decorators.registerClass()
    export class SalesOrderBOMGrid extends Serenity.EntityGrid<SalesOrderBOMRow, any> {
        protected getColumnsKey() { return 'SalesOrder.SalesOrderBOM'; }
        protected getDialogType() { return SalesOrderBOMDialog; }
        protected getIdProperty() { return SalesOrderBOMRow.idProperty; }
        protected getInsertPermission() { return SalesOrderBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesOrderBOMRow.localTextPrefix; }
        protected getService() { return SalesOrderBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}